import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/security-deposit-calculator',
  component: () => import('../../routes/SecurityDepositCalculator.svelte'),
  card: {
    id: 'security-deposit-calculator',
    title: 'Security Deposit Return',
    description: 'Calculate your security deposit refund after deductions for cleaning, repairs, and damages.',
    icon: 'home_work',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/security-deposit-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Security Deposit Return Calculator – Estimate Your Refund',
    description: 'Free security deposit calculator. Calculate your expected refund by subtracting unpaid rent, cleaning, repairs, and damages from your original deposit. Includes state-by-state return deadline guide.',
  },
};

export default meta;
